import { integrationIdFormat } from "@redotech/redo-integration-id";
import { ConnectionName } from "@redotech/redo-integrations-configs/connections/connection-types";
import { HttpMetadata } from "@redotech/redo-integrations-configs/connections/http.connection-type";
import * as z from "zod";
import { ConnectionView } from "./connection";

/**
 * Replaces the name and metadata; the connection's type and secret are
 * unchanged. The server validates `metadata` against the stored type.
 */
export const updateConnection = {
  name: "updateConnection" as const,
  input: z.object({
    id: integrationIdFormat.schema,
    name: ConnectionName,
    metadata: HttpMetadata,
  }),
  output: ConnectionView,
};
